import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { KeyImageService } from "src/app/services/key-image/key-image.service";

@Component({
  selector: "app-study-report-key-image-viewer-dialog",
  templateUrl: "./study-report-key-image-viewer-dialog.component.html",
  styleUrls: ["./study-report-key-image-viewer-dialog.component.css"],
})
export class StudyReportKeyImageViewerDialogComponent implements OnInit {
  ids: string[] = [];
  selectedIds: string[] = [];

  constructor(
    private keyImageService: KeyImageService,
    public dialogRef: MatDialogRef<StudyReportKeyImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ids = data.keyImageIds;
    this.selectAll();
  }

  selectAll(): void {
    this.selectedIds = [...this.ids];
  }

  clearSelection(): void {
    this.selectedIds = [];
  }

  selectedImage(id: string) {
    const index = this.selectedIds.findIndex((s) => s === id);
    if (index > -1) {
      this.selectedIds.splice(index, 1);
    } else {
      this.selectedIds.push(id);
    }
  }

  isSelected(id: string) {
    const index = this.selectedIds.findIndex((s) => s === id);
    return index > -1;
  }

  getImageUrl(id: string): string {
    return this.keyImageService.getKeyImageUrl(id);
  }

  async ngOnInit() {
    // this.ids = await this.keyImageService.getIdsByMedicalReportId(this.data.studyReportId);
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.dialogRef.close(this.selectedIds);
  }
}
